export const reportConstants = {
	GetReport1Chart1Paged: {
		SUCCESS : 'GET_REPORT1_CHART1_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT1_CHART1_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT1_CHART1_LIST_PAGED_FAILURE'
	},
	GetReport1Chart2Paged: {
		SUCCESS : 'GET_REPORT1_CHART2_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT1_CHART2_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT1_CHART2_LIST_PAGED_FAILURE'
	},
	GetReport2Chart1Paged: {
		SUCCESS : 'GET_REPORT2_CHART1_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT2_CHART1_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT2_CHART1_LIST_PAGED_FAILURE'
	},
	GetReport2Chart2Paged: {
		SUCCESS : 'GET_REPORT2_CHART2_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT2_CHART2_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT2_CHART2_LIST_PAGED_FAILURE'
	},
	GetReport2Chart3Paged: {
		SUCCESS : 'GET_REPORT2_CHART3_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT2_CHART3_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT2_CHART3_LIST_PAGED_FAILURE'
	},
	GetReport3Paged: {
		SUCCESS : 'GET_REPORT3_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT3_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT3_LIST_PAGED_FAILURE'
	},
	GetReport6Paged: {
		SUCCESS : 'GET_REPORT6_LIST_PAGED_SUCCESS',
		REQUEST : 'GET_REPORT6_LIST_PAGED_REQUEST',
		FAILURE : 'GET_REPORT6_LIST_PAGED_FAILURE'
	},
	GetReport7: {
		SUCCESS : 'GET_REPORT7_LIST_SUCCESS',
		REQUEST : 'GET_REPORT7_LIST_REQUEST',
		FAILURE : 'GET_REPORT7_LIST_FAILURE'
	},
	GetReport1File: {
		FAILURE : 'GET_REPORT1_RESULT_FILE_FAILURE',
		REQUEST : 'GET_REPORT1_RESULT_FILE_REQUEST',
		SUCCESS : 'GET_REPORT1_RESULT_FILE_SUCCESS'
	},
	GetIndexes: {
		FAILURE : 'GET_REPORT_INDEXES_FAILURE',
		REQUEST : 'GET_REPORT_INDEXES_REQUEST',
		SUCCESS : 'GET_REPORT_INDEXES_SUCCESS'
	},
	CLEAR: 'CLEAR_REPORT_CHART'
}